import { render } from "./LoginPageWithCaptcha.vue?vue&type=template&id=03273c4e&scoped=true"
import script from "./LoginPageWithCaptcha.vue?vue&type=script&lang=js"
export * from "./LoginPageWithCaptcha.vue?vue&type=script&lang=js"

import "./LoginPageWithCaptcha.vue?vue&type=style&index=0&id=03273c4e&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03273c4e"]])

export default __exports__